// src/components/AnimalMap.js
import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './AnimalMap.css';

const AnimalMap = ({ geojson }) => {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    mapboxgl.accessToken =
      'pk.eyJ1IjoiaHVnbzFqYW52aWVyIiwiYSI6ImNtNjRhZHN4YjFldGwydnB5MXVqNmhicGsifQ.dJnEsRVlLaHj6T3b8wt8GQ';

    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [0, 20],
      zoom: 1.5,
      projection: 'globe'
    });
    map.addControl(new mapboxgl.FullscreenControl());
    mapRef.current = map;

    map.on('style.load', () => {
      map.setFog({});
      if (geojson) {
        if (!map.getSource('rangeMap')) {
          map.addSource('rangeMap', {
            type: 'geojson',
            data: geojson
          });
          map.addLayer({
            id: 'rangeMapLayer',
            type: 'fill',
            source: 'rangeMap',
            paint: {
              'fill-color': '#088',
              'fill-opacity': 0.5
            }
          });
          map.addLayer({
            id: 'rangeMapOutline',
            type: 'line',
            source: 'rangeMap',
            paint: {
              'line-color': '#000',
              'line-width': 2
            }
          });
          // Optional: Adjust the map viewport to fit the polygon
          const bounds = new mapboxgl.LngLatBounds();
          const coordinates = geojson.coordinates;
          // Handle both Polygon and MultiPolygon
          if (geojson.type === 'Polygon') {
            coordinates[0].forEach(coord => bounds.extend(coord));
          } else if (geojson.type === 'MultiPolygon') {
            coordinates.forEach(polygon => {
              polygon[0].forEach(coord => bounds.extend(coord));
            });
          }
          map.fitBounds(bounds, { padding: 20 });
        } else {
          map.getSource('rangeMap').setData(geojson);
        }
      }
    });

    return () => {
      if (mapRef.current) {
        if (mapRef.current._controls) {
          mapRef.current._controls.forEach((control) => {
            mapRef.current.removeControl(control);
          });
        }
        mapRef.current.remove();
      }
    };
  }, [geojson]);

  return <div ref={mapContainer} className="map-container"></div>;
};

export default AnimalMap;
